<div class="jumbotron jumbotron-fluid memic-banner" style="background-color: rgb(239, 114, 96)">
  <div class="memic-banner__wrapper">
    <div class="memic-banner__body">
      <div class="memic-banner__body__inner">
        <h1 class="display-4" style="color: white !important;">Webinars on Demand</h1>
        <p class="lead" style="color: white !important;"></p>
      </div>
    </div>
    <img class="memic-banner__image" src="../../../assets/images/WebinarsOnDemandHeader.jpg">
  </div>
</div>

<div class="memic-page memic-page--boxed">
  <safetydirector-breadcrumb [pageName]="pageName"></safetydirector-breadcrumb>

  <div class="row">
    <div class="col-md-9">
      <div ngbDropdown class="d-inline-block">
        <label class="p-l-4 p-r-1 dropdown-label" for="industries">Industry</label>
        <button type="button" class="btn memic-btn--outlined" id="dropdownBasic1" ngbDropdownToggle>{{selectedIndustry}}</button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <button ngbDropdownItem *ngFor="let industry of primaryIndustries" (click)="updateIndustry(industry.name)">{{industry.name}}</button>
        </div>
      </div>
    </div>
  </div>

  <div class="p-t-4">
    <div class="row">
      <div class="col-md-3">
        <div class="memic-panel panel">
          <div class="panel-heading">
            <h3 class="panel-title">Featured Topics</h3>
          </div>

          <div class="memic-list__body p-l-1" *ngIf="featuredTopicsCheckArray && featuredTopicsCheckArray.length > 0">
            <section class="memic-refiner m-r-1 m-t-1" *ngFor="let ftc of featuredTopicsCheckArray; let i=index">
              {{ftc}}<a class="fa fa-times p-l-1 m-r-1" href="javascript:void(null)" (click)="onClearRefiner(ftc, 'featuredTopic')" aria-hidden="true"></a>
            </section>

            <a class="memic-clear-refiner m-r-1 m-t-1" href="javascript:void(null)" (click)="onResetRefiner('featuredTopic')">Clear All</a>
          </div>

          <div class="panel-body memic-list--filter">
            <div *ngFor="let featuredTopic of featuredTopics; let i=index">
              <label>
                <input type="checkbox" [value]="featuredTopic" (change)="onCheckboxChange($event, 'featuredTopic')" />
                {{featuredTopic}}
              </label>
            </div>
          </div>
        </div>

        <div class="memic-panel panel">
          <div class="panel-heading">
            <h3 class="panel-title">Secondary Featured Topics</h3>
          </div>

          <div class="memic-list__body p-l-1" *ngIf="secondaryFeaturedTopicsCheckArray && secondaryFeaturedTopicsCheckArray.length > 0">
            <section class="memic-refiner m-r-1 m-t-1" *ngFor="let stc of secondaryFeaturedTopicsCheckArray; let i=index">
              {{stc}}<a class="fa fa-times p-l-1 m-r-1" href="javascript:void(null)" (click)="onClearRefiner(stc, 'secondaryFeaturedTopic')" aria-hidden="true"></a>
            </section>

            <a class="memic-clear-refiner m-r-1 m-t-1" href="javascript:void(null)" (click)="onResetRefiner('secondaryFeaturedTopic')">Clear All</a>
          </div>

          <div class="panel-body memic-list--filter">
            <div *ngFor="let secondaryFeaturedTopic of secondaryFeaturedTopics; let i=index">
              <label>
                <input type="checkbox" [value]="secondaryFeaturedTopic" (change)="onCheckboxChange($event, 'secondaryFeaturedTopic')" />
                {{secondaryFeaturedTopic}}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-9">
        <div class="memic-panel panel memic-list p-4">
          <div *ngIf="!webinars">
            <em>Loading Webinars...</em>
          </div>

          <div *ngIf="webinars">
            <!-- Search Box -->
            <div class="memic-input-group memic-input-group--borderless input-group memic-search--page">
              <input [(ngModel)]="searchString" (keyup.enter)="filterWebinars()" name="searchString" type="text" placeholder="Search">
              <button type="button" (click)="filterWebinars(true)" class="btn bg-transparent" style="margin-left: -40px; z-index: 100;">
                <i class="fa fa-times"></i>
              </button>
              <span (click)="filterWebinars()" class="input-group-addon"><i class="fa fa-search" aria-hidden="true"></i></span>
            </div>
            <!--// Search Box -->
          </div>

          <div class="row p-b-2">
            <div class="col-md-12">
              <span class="badge badge-primary">{{webinars.length}} Webinars on Demand</span>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="row row-cols-1 row-cols-md-3 g-4">
                <div class="col m-b-3" *ngFor="let webinar of webinars; index as i;">
                  <div class="card memic-block">
                    <div class="card-body">
                      <h3 class="memic-block__header">
                        <a (click)="openModal(webinarModal, webinar)" href="javascript:void(null)">
                          <section class="memic-list__body-left">
                            <img class="memic-icn memic-icn-png" [src]="'../assets/icons/play.png'">
                          </section>
                          <section class="memic-list__body-right">
                            {{webinar.title}}
                          </section>
                        </a>
                      </h3>
                      <!-- Subheading -->
                      <div class="memic-list__body">
                        <span [ngClass]="webinar.more ? '' : 'truncate-overflow' ">
                          {{webinar.subheading}}
                        </span>
                        <!-- Subheading Toggle -->
                        <a class="memic-tag m-r-1 m-t-1 pull-right" href="javascript:void(null)" (click)="toggleSubheading(webinar)">
                          <i class="fa p-l-1 m-r-1" [ngClass]="{'fa-plus': !webinar.more, 'fa-minus' : webinar.more }" aria-hidden="true"> </i>
                          <span *ngIf="!webinar.more" class="p-r-1">more</span>
                          <span *ngIf="webinar.more" class="p-r-1">less</span>
                        </a>
                        <!-- // Subheading -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>

<!-- Webinar Modal Dialog -->
<ng-template #webinarModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="editProfileLabel">Webinars On Demand</h4>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row m-b-3">
      <div class="col-md-12">
        <h3>{{selectedWebinar.title}}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <iframe [src]="selectedWebinarUrl" width="750" height="425" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
      </div>
      <div class="col-md-4">
        <p class="memic-webinars--description">{{selectedWebinar.subheading}}</p>
        <div *ngIf="selectedWebinar.relatedDocument!.length > 0" class="memic-panel panel">
          <div class="panel-heading">
            <h3 class="panel-title">Related Documents</h3>
          </div>
          <div class="panel-body">
            <ul class="memic-list memic-list--details memic-list--brdless list-group m-a-0" *ngFor="let document of selectedWebinar.relatedDocument;">
              <li class="memic-list__body list-group-item p-x-0">
                <div class="memic-list__body-left">
                  <img #fileIcon class="memic-icn memic-icn-png" [src]="'../assets/icons/' + document.blobExtension.replace('.', '') +'.png'">
                </div>
                <div class="memic-list__body-right">
                  <header class="memic-list__header">
                    <h2 class="memic-list__title"><a href="javascript:void(null)" (click)="downloadFile(document, fileIcon)">{{document.title}}</a></h2>
                  </header>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
